import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { JsonRpcProvider } from "ethers";
import { getProvider } from "@/config/net";
import { DEFAULT_RPC } from "@/config";

interface ProviderState {
  provider: JsonRpcProvider | null;
  isLoading: boolean;
  error: Error | null;
}

export function useProvider(): ProviderState {
  const { rpc } = useSelector((state: any) => state.projectControll);
  const [state, setState] = useState<ProviderState>({
    provider: getProvider(rpc ? rpc : DEFAULT_RPC),
    isLoading: true,
    error: null,
  });

  useEffect(() => {
    if (rpc) {
      // console.log("rpc change", rpc);

      setState((prev) => ({ ...prev, isLoading: true }));
      try {
        const newProvider = getProvider(rpc);
        setState({
          provider: newProvider,
          isLoading: false,
          error: null,
        });
      } catch (error) {
        console.error("创建Provider失败，使用默认rpc", error);
        setState({
          provider: getProvider(DEFAULT_RPC),
          isLoading: false,
          error: error as Error,
        });
      }
    }
  }, [rpc]);

  // console.log("useProvider rpc", rpc);

  return state;
}
